import styles from "./loginotpblock.module.css";
import InputEmailorPhone from "../InputEmailorPhone";
import { useTranslation } from "react-i18next";
import LoginWithGoogleButton from "../LoginWithGoogleButton";
import LoginWithFacebookButton from "../LoginWithFacebookButton";
import LoginWithTiktokButton from "../LoginWithTiktokButton";
import { useState } from "react";
import OTPLoginButton from "../OTPLoginButton";
import LoginOTPVerifyBlock from "../LoginOTPVerifyBlock";

export default function LoginOTPBlock() {
  const { t } = useTranslation();

  const [errorEmailPhone, setErrorEmailPhone] = useState("");
  const [emailPhoneValue, setEmailPhoneValue] = useState("");

  const [showOTPForm, setShowOTPForm] = useState(false);

  return showOTPForm
    ? <LoginOTPVerifyBlock emailPhoneValue={emailPhoneValue}/>
  :
    <div className={styles.loginBlock}>
      <h2 className={styles.loginText}>{t("login")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputEmailorPhone
            emailPhoneValue={emailPhoneValue}
            setEmailPhoneValue={setEmailPhoneValue}
            setErrorEmailPhone={setErrorEmailPhone}
          />
        </div>
        <span className={styles.errorText}>{t(errorEmailPhone)}</span>
      </div>
      <div className={`col-12 ${styles.loginButtonContainer}`}>
        <OTPLoginButton
          errorEmailPhone={errorEmailPhone}
          emailPhoneValue={emailPhoneValue}
          setErrorEmailPhone={setErrorEmailPhone}
          setShowOTPForm={setShowOTPForm}
        />
      </div>
      <div className={styles.linkBlock}>
        <a href="login">{t("login_with_password")}</a>
      </div>
      <div className={`col-12 ${styles.hrContainer}`}>
        <hr className={styles.leftHr} />
        <span className={styles.hrText}>{t("or")}</span>
        <hr className={styles.rightHr} />
      </div>
      <div className={`col-12 ${styles.loginWithBlock}`}>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithGoogleButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithFacebookButton />
        </div>
        {/* <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithTiktokButton />
        </div> */}
      </div>
      <p className="col-12 d-flex justify-content-center">
        {t("first_time_bhive")} <a href="/signup">{t("signup")}</a>
      </p>
    </div>
}
